// src/locales/ta/ecomOrders.js (Tamil Translation)
export const ecomOrders = {
  // Page titles and navigation
  createNewOrder: 'புதிய Online ஆர்டர் உருவாக்கு',
  addNewOrderToSystem: 'புதிய இ-காமர்ஸ் ஆர்டரை கணினி அமைப்பில் சேர்',
  backToOrders: 'Orders க்கு திரும்ப',
  allOrders: 'அனைத்து Online Orders',
  addOrder: 'Order சேர்',
  editOrder: 'Online Order திருத்து',
  deleteOrder: 'Order நீக்கு',
  viewOrderDetails: 'Order விவரங்கள் பார்க்க',

  // Form sections
  shopSelection: 'Shop தேர்வு',
  customerInformation: 'வாடிக்கையாளர் தகவல்',
  orderItems: 'Order Items',
  orderStatusAndType: 'Order நிலை & கட்டண வகை',
  paymentRecords: 'கட்டண பதிவுகள்',
  replacementOrders: 'மாற்று Order விவரங்கள்',
  orderSummary: 'Order சுருக்கம்',

  // Shop selection
  selectShop: 'Shop தேர்ந்தெடுக்கவும்',
  selectShopRequired: 'Shop தேர்வு அவசியம்',
  shopSelectionDesc: 'இந்த ஆர்டருக்கு எந்த Shop என்பதை தேர்வு செய்யவும்',
  currentShop: 'தேர்ந்தெடுக்கப்பட்ட Shop',
  changeShop: 'Shop மாற்று',
  shopCannotBeChanged: 'Order உருவாக்கப்பட்ட பின்னர் Shop மாற்ற முடியாது',

  // Customer information
  customerName: 'வாடிக்கையாளர் பெயர்',
  customerNameRequired: 'வாடிக்கையாளர் பெயர் அவசியம்',
  customerNamePlaceholder: 'முழு பெயரை உள்ளிடவும்',

  privateReference: 'பிரத்தியேக குறிப்பு',
  privateReferencePlaceholder: 'Internal reference (விரும்பினால்)',

  address: 'விநியோக முகவரி',
  addressRequired: 'விநியோக முகவரி அவசியம்',
  addressPlaceholder: 'முழு விநியோக முகவரியை உள்ளிடவும்',

  city: 'விநியோக நகரம்',
  cityRequired: 'நகரம் தேர்வு அவசியம்',
  selectCity: 'நகரம் தேர்வுசெய்',
  searchCity: "நகரம் தேடு...",

  phoneNumbers: 'தொலைபேசி எண்கள்',
  phoneNumbersRequired: 'குறைந்தது ஒரு தொலைபேசி எண் அவசியம்',
  phoneNumber: 'தொலைபேசி எண்',
  phoneNumberPlaceholder: 'தொலைபேசி எண்ணை உள்ளிடவும்',
  addPhoneNumber: 'எண் சேர்க்கவும்',
  removePhoneNumber: 'எண் நீக்கவும்',
  primaryPhone: 'Primary',
  setPrimaryPhone: 'Primary ஆக்கு',
  primaryPhoneRequired: 'ஒரு primary number அமைக்கவும்',

  phoneLookupAutofilled: '{{source}} இலிருந்து தகவல்கள் தானாக நிரப்பப்பட்டன',
  phoneLookupSourcePos: 'POS வாடிக்கையாளர்',
  phoneLookupSourceOrder: 'முந்தைய ஆர்டர்',

  customerEmail: 'Email',
  customerEmailPlaceholder: 'Email (விரும்பினால்)',
  invalidEmailFormat: 'Email வடிவம் தவறு',

  deliveryNotes: 'விநியோக குறிப்புகள்',
  deliveryNotesPlaceholder: 'சிறப்பு வழிமுறைகள் (விரும்பினால்)',

  specialNotes: 'சிறப்பு குறிப்புகள்',
  specialNotesPlaceholder: 'கூடுதல் தகவல் (விரும்பினால்)',

  // Order items
  searchProducts: 'பொருட்களை தேடவும்',
  searchProductsPlaceholder: 'பெயர் / SKU / Barcode மூலம் தேடு...',
  addProduct: 'பொருள் சேர்க்க',
  noProductsFound: 'பொருட்கள் இல்லை',
  productRequired: 'பொருள் தேர்வு அவசியம்',

  product: 'பொருள்',
  quantity: 'அளவு',
  quantityRequired: 'அளவு அவசியம்',
  quantityMinimum: 'அளவு குறைந்தது 1 ஆக இருக்க வேண்டும்',

  unitPrice: 'Unit விலை',
  unitPriceRequired: 'Unit விலை அவசியம்',
  unitPriceMinimum: 'Unit விலை 0-ஐ விட அதிகமாக இருக்க வேண்டும்',

  lineDiscount: 'Discount',
  lineDiscountPlaceholder: 'Discount (விரும்பினால்)',
  lineDiscountMaximum: 'Discount Line Total-ஐ விட அதிகமாக இருக்க முடியாது',

  lineTotal: 'Line Total',
  removeItem: 'Remove',

  atLeastOneItemRequired: 'குறைந்தது ஒரு பொருள் தேவையானது',

  // Product search results
  productResults: 'பொருள் முடிவுகள்',
  selectProduct: 'பொருள் தேர்வு செய்யவும்',
  productSku: 'SKU',
  productStock: 'Stock',
  productPrice: 'விலை',
  productAttributes: 'Attributes',

  // Order status and payment
  orderStatus: 'Order நிலை',
  orderStatusRequired: 'Order நிலை தேர்வு செய்யவும்',

  statusReason: 'நிலையின் காரணம்',
  statusReasonRequired: 'இந்த Status-க்கு காரணம் தேவை',
  selectStatusReason: 'காரணம் தேர்ந்தெடுக்கவும்',

  holdUntilDate: 'Hold Until தேதி',
  holdUntilDateRequired: 'தேதி அவசியம்',

  paymentType: "கட்டண வகை",
  paymentTypeRequired: 'கட்டண வகை தேர்வு செய்யவும்',
  paymentTypeLockedHint: 'ஒரு கட்டணம் சரிபார்க்கப்பட்டவுடன் கட்டண வகையை மாற்ற முடியாது',
  editPaymentsAndShift: 'கட்டணங்கள் & Shift',
  selectPaidPaymentTypeFirst: 'கட்டணங்களைச் சேர்க்க Fully Paid அல்லது Partially Paid-ஐத் தேர்ந்தெடுக்கவும்',
  outstandingBalance: 'நிலுவைத் தொகை',
  confirmPayment: 'கட்டணத்தை உறுதிப்படுத்து',
  paymentRecordedSuccess: 'கட்டணம் வெற்றிகரமாக பதிவு செய்யப்பட்டது',
  failedToRecordPayment: 'கட்டணத்தைப் பதிவு செய்ய முடியவில்லை',
  confirmDeletePaymentRecord: 'சரிபார்க்கப்படாத இந்த கட்டணப் பதிவை நீக்கவா?',
  messageCenterShift: 'Message Center Shift',
  saveShift: 'Shift-ஐ சேமி',
  shiftUpdatedSuccess: 'Shift வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  paymentTypeUpdatedSuccess: 'கட்டண வகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது',

  // Replacement orders
  replacedOrderId: 'Original Order Number',
  replacedOrderIdRequired: 'Original Order Number தேவையானது',
  replacedOrderIdPlaceholder: 'Original Order Number',

  replacementReason: 'மாற்று காரணம்',
  replacementReasonRequired: 'Reason தேவையானது',
  selectReplacementReason: 'காரணம் தேர்வு செய்யவும்',

  returnAirwaybillNumber: 'Return Airwaybill எண்',
  returnAirwaybillNumberPlaceholder: 'Return parcel airwaybill எண்ணை உள்ளிடவும் (விருப்பமானது)',
  itemsToReturn: 'திரும்பப் பெற வேண்டிய பொருட்கள்',
  item: 'பொருள்',
  remainingReturnableQty: 'மீதமுள்ள திரும்பக்கொடுக்கக்கூடிய அளவு',
  returnQuantity: 'திரும்பக் கொடுக்கும் அளவு',
  returnQuantityExceedsRemaining: 'திரும்பக் கொடுக்கும் அளவு மீதமுள்ள அளவை விட அதிகமாக உள்ளது',
  returnPackageOrder: 'Return Package Order',
  returnPackageOrderCreated: 'Return package order உருவாக்கப்பட்டது',

  // Payment records
  paymentRecordsRequired: "இந்தக் கட்டண வகைக்குக் கட்டணப் பதிவுகள் தேவை",
  paymentRecordsOptional: "இந்தக் கட்டண வகைக்குக் கட்டணப் பதிவுகள் விருப்பத்தேர்வு",
  addPaymentRecord: "கட்டணப் பதிவைச் சேர்க்கவும்",
  removePaymentRecord: "கட்டணப் பதிவை நீக்கவும்",

  paymentMethod: 'கட்டண முறை',
  paymentMethodRequired: 'கட்டண முறை தேவையானது',
  selectPaymentMethod: 'கட்டண முறையை தேர்வு செய்',

  paymentAmount: 'கட்டணம்',
  paymentAmountRequired: 'கட்டண தொகை தேவையானது',
  paymentAmountMinimum: 'கட்டணம் 0-ஐ விட அதிகமாக இருக்க வேண்டும்',

  paymentReference: "கட்டணக் குறிப்பு",
  paymentReferencePlaceholder: 'Receipt / Transaction Ref',

  paymentDate: "கட்டணத் தேதி",
  paymentDateRequired: "கட்டணத் தேதி தேவை",

  totalPaid: 'Paid Amount',
  paymentBalance: "நிலுவை",
  codToCollect: "வசூலிக்க வேண்டிய COD",
  overpaidAmount: "அதிகமாகச் செலுத்தியது",

  // Order summary & calculations
  subtotal: 'Subtotal',
  totalDiscount: 'Total Discount',
  deliveryCharge: 'Delivery Charge',
  tax: 'Tax',
  grandTotal: 'Grand Total',

  // Delivery charges
  calculatingDeliveryCharge: 'Delivery charge கணக்கிடப்படுகிறது...',
  deliveryChargeCalculated: 'Delivery charge கணக்கிடப்பட்டது',
  deliveryNotAvailable: 'இந்த முகவரிக்கு விநியோகம் கிடைக்கவில்லை',
  deliveryChargeFailed: 'Delivery charge கணக்கிட முடியவில்லை',

  // Form actions
  createOrder: 'Order உருவாக்கு',
  updateOrder: 'Order புதுப்பிக்கவும்',
  saveOrder: 'Order சேமிக்கவும்',
  cancel: 'Cancel',

  // Success messages
  orderCreatedSuccess: 'Order "{{orderNumber}}" வெற்றிகரமாக உருவாக்கப்பட்டது!',
  orderUpdatedSuccess: 'Order வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  orderSavedSuccess: 'Order save செய்யப்பட்டது',

  // Error messages
  failedToCreateOrder: 'Order உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  failedToUpdateOrder: 'Order புதுப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  failedToLoadOrder: 'Order விவரங்களை Load செய்ய முடியவில்லை.',
  failedToLoadReferenceData: 'தேவையான data load செய்ய முடியவில்லை. Refresh செய்யவும்.',

  someFieldsRequired: 'அனைத்து தேவையான புலங்கள் நிரப்பவும்',
  invalidOrderData: 'Order தரவு தவறாக உள்ளது',
  noChangesDetected: 'Changes ஏதும் இல்லை',

  // Loading states
  loadingReferenceData: 'Reference data load ஆகிறது...',
  loadingOrder: 'Order load ஆகிறது...',
  savingOrder: 'Order save ஆகிறது...',
  calculatingTotals: 'கணக்கிடப்படுகிறது...',

  // Validation messages
  required: 'தேவையானது',
  optional: 'விரும்பினால்',
  invalidPhoneNumber: 'தவறான தொலைபேசி எண்',
  duplicatePhoneNumber: 'இந்த தொலைபேசி எண் ஏற்கனவே உள்ளது',

  // Permission errors
  insufficientPermissions: 'இந்த செயலை செய்ய அனுமதி இல்லை',
  cannotChangeUnitPrice: 'Unit விலை மாற்ற அனுமதி இல்லை',
  cannotGiveDiscount: 'Discount வழங்க அனுமதி இல்லை',
  cannotChangeDeliveryCharge: 'Delivery charge மாற்ற முடியாது',

  // Order number
  orderNumber: 'Order Number',
  orderNumberPreview: 'Order Number முன்னோட்டம்',
  generatedOrderNumber: 'உருவாக்கப்பட்ட Order Number',

  // Order list
  ordersList: 'Orders பட்டியல்',
  searchOrders: 'Orders தேடவும்...',
  filterByStatus: 'நிலையை அடிப்படையாக Filter செய்',
  filterByPaymentType: "கட்டண வகை மூலம் வடிகட்டு",
  filterByShop: 'Shop அடிப்படையில் Filter',
  filterByCity: 'City அடிப்படையில் Filter',

  noOrdersFound: 'Orders இல்லை',
  noOrdersYet: 'Orders இன்னும் இல்லை',

  // Date ranges
  today: 'இன்று',
  yesterday: 'நேற்று',
  thisWeek: 'இந்த வாரம்',
  thisMonth: 'இந்த மாதம்',

  // Order statuses
  pending: 'Pending',
  confirmed: 'Confirmed',
  hold: 'Hold',
  notConfirmed: 'Not Confirmed',
  cancelled: 'Cancelled',
  inCourier: 'Courier-இல் உள்ளது',
  settled: 'Settled',
  returned: 'Returned',

  // Payment types
  cashOnDelivery: 'Cash On Delivery',
  fullyPaid: 'முழு கட்டணம்',
  partiallyPaid: "பகுதியாகச் செலுத்தப்பட்டது",
  replacement: 'Replacement',

  // Payment methods
  cash: 'Cash',
  bankTransfer: 'Bank Transfer',
  cheque: 'Cheque',
  cardPayment: "அட்டைக் கட்டணம்",

  // Common UI
  loading: 'Loading...',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  view: 'View',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  reset: 'Reset',

  // Keyboard navigation
  enterToSelect: 'தேர்ந்தெடுக்க Enter அழுத்தவும்',
  escapeToClose: 'மூட Escape அழுத்தவும்',
  arrowKeysToNavigate: 'இயக்க Arrow keys பயன்படுத்தவும்',

  // Accessibility
  selectOption: 'Option தேர்வு செய்',
  selectedOption: 'தேர்ந்தெடுக்கப்பட்ட Option',
  optionsAvailable: '{{count}} Options உள்ளது',
  noOptionsAvailable: 'Options இல்லை',

  // Bulk Order Creation
  bulkOrderCreate: 'Bulk Orders உருவாக்க',
  bulkOrderCreateDesc: 'Excel file upload செய்து ஒரே சமயத்தில் Orders உருவாக்கவும்',
  downloadTemplate: 'Template பதிவிறக்கவும்',
  uploadFile: 'File Upload செய்',
  validateOrders: 'Orders Validate செய்',
  submitOrders: 'Orders Submit செய்',
  submitValidOrders: '{{count}} Valid Orders Submit செய்',
  retryValidation: 'Fix & Revalidate',
  clearAll: 'All Clear செய்',

  // File Upload
  dragDropFile: 'Excel File ஐ இங்கே drag & drop செய்யவும்',
  orClickToSelect: 'அல்லது file தேர்வு செய்ய கிளிக் செய்க',
  supportedFormats: 'அங்கீகரிக்கப்பட்ட formats: .xlsx, .csv',
  fileUploaded: 'File successfully upload செய்யப்பட்டது',
  fileName: 'File Name',
  rowCount: '{{count}} rows',
  removeFile: 'File நீக்கு',

  // Data Preview
  dataPreview: 'Data Preview',
  showingRows: '{{count}} Orders காட்டுகிறது',
  validRows: '{{count}} Valid',
  invalidRows: '{{count}} Invalid',
  editRow: 'Row Edit செய்',
  deleteRow: 'Row Delete செய்',

  // Validation
  validating: 'Orders Validate செய்யப்படுகிறது...',
  validationComplete: 'Validation முடிந்தது',
  validationErrors: 'Validation Errors உள்ளது',
  validOrder: 'Valid Order',
  invalidOrder: 'Invalid Order',
  validationDetails: 'Validation விவரங்கள்',

  // Submission
  submitting: 'Orders Submit ஆகிறது...',
  submissionComplete: 'Submit முடிந்தது',
  ordersCreatedSuccessfully: '{{count}} Orders வெற்றிகரமாக உருவாக்கப்பட்டது',
  ordersFailed: '{{count}} Orders தோல்வி',
  viewCreatedOrders: 'உருவாக்கப்பட்ட Orders பார்க்க',
  createMoreOrders: 'மேலும் Orders உருவாக்க',

  // Progress
  processingOrders: 'Orders செயல்படுகிறது...',
  validatingOrder: '{{total}} இல் {{current}} Order Validate செய்கிறது...',
  creatingOrder: '{{total}} இல் {{current}} Order உருவாக்கப்படுகிறது...',

  // Errors
  noShopSelected: 'Shop முதலில் தேர்வு செய்க',
  noFileUploaded: 'File upload செய்யவும்',
  invalidFileFormat: 'தவறான File format (.xlsx / .csv மட்டும் அனுமதி)',
  fileParsingError: 'File வாசிப்பு பிழை. Format ஐ சரிபார்க்கவும்',
  noOrdersFound: 'File-இல் Orders இல்லை',
  validationFailed: 'Validation தோல்வி. பிழைகள் சரிசெய்து முயற்சிக்கவும்',
  submissionFailed: 'சில Orders உருவாக்க முடியவில்லை',

  // Column Names
  columnCustomerName: 'Customer Name',
  columnCustomerEmail: 'Email',
  columnAddress: 'Address',
  columnPhone1: 'Phone 1',
  columnPhone2: 'Phone 2',
  columnCityName: 'City Name',
  columnPaymentType: "கட்டண வகை",
  columnOrderStatus: 'Order Status',
  columnPrivateReference: 'Private Reference',
  columnDeliveryNotes: 'Delivery Notes',
  columnSpecialNotes: 'Special Notes',
  columnItemSku: 'Item {{number}} SKU',
  columnItemQuantity: 'Item {{number}} Quantity',
  columnItemCustomLineTotal: 'Item {{number}} Custom Line Total',
  columnDeliveryCharge: 'Delivery Charge',
  columnTotalDiscount: 'Total Discount',

  // Table Headers
  row: 'Row',
  status: 'Status',
  customer: 'Customer',
  items: 'Items',
  total: 'Total',
  errors: 'Errors',
  actions: 'Actions',

  // Order list page - MISSING SECTION
  totalOrders: 'மொத்த Orders',
  allShops: 'அனைத்து Shops',
  allCities: 'அனைத்து Cities',
  allStatuses: 'அனைத்து Statuses',
  allPaymentTypes: "அனைத்து கட்டண வகைகள்",
  fromDate: 'தொடக்க தேதி',
  toDate: 'முடிவு தேதி',
  viewManageOrders: 'அனைத்து e-commerce orders-ஐ பார்க்கவும் மற்றும் நிர்வகிக்கவும்',
  searchOrdersPlaceholder: 'Order number, airwaybill number, customer name, phone, அல்லது private reference மூலம் தேடவும்... (பல மதிப்புகளை paste செய்யவும்)',
  loadingOrders: 'Orders load ஆகும் வரை காத்திருக்கவும்...',
  unableToLoadOrders: 'Orders-ஐ Load செய்ய முடியவில்லை',
  noOrdersFoundDescription: 'உங்கள் தேடல் நிபந்தனைகளுக்கு பொருந்தும் orders இல்லை',
  startCreatingOrders: 'உங்கள் முதல் order-ஐ உருவாக்குவதன் மூலம் தொடங்கவும்',
  courier: 'Courier',
  shop: 'Shop',
  products: 'Products',
  
  // Order details modal - MISSING SECTION
  orderDetails: 'Order விவரங்கள்',
  shopName: 'Shop பெயர்',
  courierInformation: 'Courier தகவல்',
  airwaybillNumber: 'Airwaybill Number',
  courierName: 'Courier பெயர்',
  courierStatus: 'Courier Status',
  additionalInformation: 'கூடுதல் தகவல்',
  updatedAt: 'புதுப்பிக்கப்பட்ட தேதி',
  createdAt: 'உருவாக்கப்பட்ட தேதி',
  createdBy: 'உருவாக்கியவர்',
  confirmedBy: 'உறுதிப்படுத்தியவர்',
  confirmedAt: 'உறுதிப்படுத்திய தேதி',
  
  // Order Details Page (NEW) - MISSING SECTION
  currentStatus: 'தற்போதைய Status',
  trackingDetails: 'Tracking விவரங்கள்',
  packageTimeline: 'Package Timeline',
  codValue: 'COD Value',
  totalCourierFees: 'மொத்த Courier Fees',
  courierStatusUpdatedAt: 'Courier Status புதுப்பிக்கப்பட்ட தேதி',
  paidAmount: 'செலுத்திய தொகை',
  codAmount: 'COD தொகை',
  dispatchedDate: 'Dispatch செய்யப்பட்ட தேதி',
  shiftDate: 'Shift Date',
  shiftType: 'Shift Type',
  allShiftTypes: 'All shift types',

  // Audit History (NEW) - MISSING SECTION
  auditHistory: 'மாற்றங்கள் வரலாறு',
  totalChanges: 'மொத்த மாற்றங்கள்',
  lastModified: 'கடைசியாக மாற்றப்பட்ட தேதி',
  modifiedBy: 'மாற்றியவர்',
  noAuditHistory: 'மாற்றங்கள் வரலாறு கிடைக்கவில்லை',
  failedToLoadAuditHistory: 'Audit history load செய்ய முடியவில்லை',
  
  // Courier Tracking (NEW) - MISSING SECTION
  failedToLoadCourierTracking: 'Courier tracking தகவல் load செய்ய முடியவில்லை',
  loadingTracking: 'Tracking தகவல் load ஆகிறது...',
  noTrackingEvents: 'இன்னும் tracking நிகழ்வுகள் இல்லை',
  latest: 'சமீபத்தியது',
  viewPackageTimeline: 'பொதி காலவரிசையைப் பார்க்கவும்',

  // Actions (NEW) - MISSING SECTION
  show: 'காட்டு',
  hide: 'மறை',
  
  // Call Attempts (NEW) - MISSING SECTION
  callAttempts: 'Call முயற்சிகள்',

  // Related Documents - MISSING SECTION
  relatedDocuments: 'தொடர்புடைய Documents',
  packingBatches: 'Packing Batches',
  returnBatches: 'Return Batches',
  courierInvoices: 'Courier Invoices',
  failedToLoadRelations: 'தொடர்புடைய documents load செய்ய முடியவில்லை',

  // Filter labels - MISSING SECTION
  allBusinessCouriers: 'அனைத்து Business Couriers',
  businessCourier: 'Business Courier',
  allCourierStatuses: 'அனைத்து Courier Statuses',

  // Permission errors - MISSING SECTION
  noPermissionEditDispatchedOrders: 'Dispatch செய்யப்பட்ட orders-ஐ edit செய்ய அனுமதி இல்லை',
  noPermissionEditInPackingOrders: 'Packing நிலையில் உள்ள orders-ஐ edit செய்ய அனுமதி இல்லை',

  // Weight
  weight: 'எடை',
  weightKg: 'எடை (kg)',

  // Order Origin
  orderOrigin: 'Order Origin',
  paid: "செலுத்தப்பட்டது",
  organic: 'Organic',
  viewShift: "ஷிஃப்டைக் காண்க",

  // Export
  exportConfirmTitle: "ஆர்டர்களை ஏற்றுமதி செய்",
  exportConfirmMessage: "தற்போதைய வடிகட்டிகளுக்குப் பொருந்தும் {{count}} ஆர்டர்களை CSV ஆக ஏற்றுமதி செய்யவா?",
  exportCapNote: "முதல் {{max}} ஆர்டர்கள் மட்டுமே ஏற்றுமதி செய்யப்படும்.",
  exportingOrders: "ஆர்டர்கள் ஏற்றுமதி செய்யப்படுகின்றன",
  noOrdersToExport: "தற்போதைய வடிகட்டிகளுடன் ஏற்றுமதி செய்ய ஆர்டர்கள் இல்லை.",
  exportAlreadyRunning: "ஏற்கனவே ஒரு ஏற்றுமதி நடைபெறுகிறது. அதை ரத்து செய்யவும் அல்லது முடியும் வரை காத்திருக்கவும்.",
  exportCompleteBackground: "ஏற்றுமதி முடிந்தது. உங்கள் கோப்பு பதிவிறக்கம் செய்யப்பட்டது.",

  // Shop change
  shopChangeTitle: "கடையை மாற்று",
  shopChangeClearsItems: "கடையை மாற்றினால் தேர்ந்தெடுக்கப்பட்ட ஆர்டர் பொருட்கள் அழிக்கப்படும். தொடரவா?",

  // Payment Proof
  paymentProof: "கட்டணச் சான்று",
  uploadProof: "சான்றைப் பதிவேற்றவும்",
  changeProof: "மாற்று",
  viewProofPdf: "பதிவேற்றிய PDF ஐப் பார்க்கவும்",
  invalidProofFormat: ".jpg, .png அல்லது .pdf கோப்புகள் மட்டுமே அனுமதிக்கப்படும்",
  proofTooLarge: "கோப்பு 5MB க்குக் குறைவாக இருக்க வேண்டும்",
  proofUploadFailed: "பதிவேற்றம் தோல்வியடைந்தது, மீண்டும் முயற்சிக்கவும்",

  // Cross Sell
  crossSellItem: 'Cross Sell Item',
  bundle: 'தொகுப்பு',
  bundleQuantity: 'தொகுப்பு அளவு',
  bundleComponents: 'தொகுப்பு பொருட்கள்',
  bundleTotal: 'தொகுப்பு மொத்தம்',
  free: 'இலவசம்',
  removeBundle: 'தொகுப்பை நீக்கு',
  crossSellBundles: 'Cross Sell (தொகுப்புகள்)',
  crossSellQuantity: 'Cross sold qty',

  // Message Center Shift
  selectDate: 'Select date',
  selectShift: 'Select shift',
  noShiftsForDate: 'No shifts for date',
  rememberShift: 'நினைவில் வை',
  rememberShiftHint: 'இந்த ஷிப்டை நினைவில் வைத்து, அடுத்த முறை தானாக ஏற்றவும்',
  paymentRecordsNotRequired: "கட்டணப் பதிவுகள் தேவையில்லை",
  paymentRecordsNotRequiredHint: "\"முழுமையாகச் செலுத்தப்பட்டது\" அல்லது \"பகுதியாகச் செலுத்தப்பட்டது\" கட்டண வகைகளுக்கு மட்டுமே கட்டணப் பதிவுகள் தேவை.",
  verifiedPaymentRecord: "சரிபார்க்கப்பட்டது",
  paymentRecordChange: "கட்டணப் பதிவு",
  auditItemAdded: "பொருள் சேர்க்கப்பட்டது",
  auditItemRemoved: "பொருள் நீக்கப்பட்டது",
  auditItemUpdated: "பொருள் புதுப்பிக்கப்பட்டது",
  auditBundleTag: "தொகுப்பு: {{name}}",
  invalidPaymentType: "தவறான கட்டண வகை",
  paymentRecordNumber: "கட்டணப் பதிவு #{number}",
  paymentSummary: "கட்டணச் சுருக்கம்",
  orderTotal: "ஆர்டர் மொத்தம்",
  paymentOverpaid: "அதிகமாகச் செலுத்தப்பட்டது",
  paymentFullyPaid: "முழுமையாகச் செலுத்தப்பட்டது",
  paymentPending: "கட்டணம் நிலுவையில்",
  noRemainingBalance: "கட்டணப் பதிவைச் சேர்க்க மீதமுள்ள நிலுவை இல்லை",
  orderFieldSettings: "புல அமைப்புகள்",
  orderFieldSettingsDescription: "ஆர்டரை உருவாக்கும்போது அல்லது திருத்தும்போது தேவையான புலங்களைத் தேர்ந்தெடுக்கவும்.",
  enableFieldRequirements: "தேவையான புலங்களைத் தனிப்பயனாக்கு",
  enableFieldRequirementsHelp: "முடக்கப்பட்டால், இந்த அனைத்து புலங்களும் விருப்பமானவை",
  fieldRequired: "தேவை",
  fieldOptional: "விருப்பம்",
  orderFieldSettingsSaved: "ஆர்டர் புல அமைப்புகள் சேமிக்கப்பட்டன",
  orderFieldSettingsSaveFailed: "ஆர்டர் புல அமைப்புகளைச் சேமிக்க முடியவில்லை",
  privateReferencePlaceholderRequired: "Internal reference",
  customerEmailPlaceholderRequired: "Email",
  deliveryNotesPlaceholderRequired: "சிறப்பு வழிமுறைகள்",
  specialNotesPlaceholderRequired: "கூடுதல் தகவல்",
  clientRemarks: "வாடிக்கையாளர் குறிப்புகள்",
  validation: {
    shopRequired: "கடை தேர்வு தேவை",
    customerNameRequired: "வாடிக்கையாளர் பெயர் தேவை",
    addressRequired: "விநியோக முகவரி தேவை",
    cityRequired: "விநியோக நகரம் தேவை",
    phoneRequired: "குறைந்தது ஒரு தொலைபேசி எண் தேவை",
    primaryPhoneRequired: "ஒரு தொலைபேசி எண்ணை முதன்மையாக அமைக்கவும்",
    privateReferenceRequired: "தனிப்பட்ட குறிப்பு தேவை",
    customerEmailRequired: "வாடிக்கையாளர் மின்னஞ்சல் தேவை",
    deliveryNotesRequired: "விநியோக குறிப்புகள் தேவை",
    specialNotesRequired: "சிறப்பு குறிப்புகள் தேவை",
    orderOriginRequired: "ஆர்டர் மூலம் தேவை",
    invalidEmail: "தவறான மின்னஞ்சல் வடிவம்",
    orderItemsRequired: "குறைந்தது ஒரு ஆர்டர் பொருள் தேவை",
    quantityInvalid: "அளவு 0 ஐ விட அதிகமாக இருக்க வேண்டும்",
    unitPriceInvalid: "அலகு விலை 0 ஐ விட அதிகமாக இருக்க வேண்டும்",
    discountNegative: "தள்ளுபடி எதிர்மறையாக இருக்க முடியாது",
    discountExceedsLine: "தள்ளுபடி வரி மதிப்பை விட அதிகமாக இருக்க முடியாது",
    deliveryChargeNegative: "டெலிவரி கட்டணம் எதிர்மறையாக இருக்க முடியாது",
    duplicatePhone: "இந்த தொலைபேசி எண் ஏற்கனவே சேர்க்கப்பட்டுள்ளது",
    orderStatusRequired: "ஆர்டர் நிலை தேவை",
    paymentTypeRequired: "கட்டண வகை தேவை",
    statusReasonRequired: "இந்த நிலைக்கு காரணம் தேவை",
    holdDateRequired: "இந்த நிலைக்கு நிறுத்தி வைக்கும் தேதி தேவை",
    replacedOrderRequired: "மாற்று ஆர்டர்களுக்கு அசல் ஆர்டர் எண் அல்லது airwaybill தேவை",
    orderLookupPending: "ஆர்டரைத் தேடும் வரை காத்திருக்கவும்",
    validReplacedOrderRequired: "சரியான ஆர்டர் எண் அல்லது airwaybill தேவை",
    replacementReasonRequired: "மாற்று காரணம் தேவை",
    replacementCodRequired: "மாற்று ஆர்டர்களுக்கு COD தொகை தேவை",
    replacementCodNegative: "COD தொகை 0 அல்லது அதற்கு மேல் இருக்க வேண்டும்",
    replacementCodExceeds: "COD தொகை மொத்தத் தொகையை மீறக்கூடாது",
    returnQtyExceeds: "ஒன்று அல்லது அதற்கு மேற்பட்ட பொருட்களுக்கு திருப்பும் அளவு மீதமுள்ள அளவை மீறுகிறது",
    paymentRecordsRequired: "இந்த கட்டண வகைக்கு கட்டணப் பதிவுகள் தேவை",
    paymentMethodRequired: "கட்டண முறை தேவை",
    paymentAmountInvalid: "கட்டணத் தொகை 0 ஐ விட அதிகமாக இருக்க வேண்டும்",
    paymentDateRequired: "கட்டண தேதி தேவை",
    fullyPaidIncomplete: "கட்டணம் முழுமையடையவில்லை. முழுமையாக செலுத்திய ஆர்டர்களுக்கு செலுத்திய தொகை ({{totalPaid}}) மொத்தத் தொகைக்கு ({{grandTotal}}) சமமாக இருக்க வேண்டும்.",
    fullyPaidOverpaid: "ஆர்டருக்கு அதிகமாக செலுத்தப்பட்டுள்ளது. முழுமையாக செலுத்திய ஆர்டர்களுக்கு செலுத்திய தொகை ({{totalPaid}}) மொத்தத் தொகைக்கு ({{grandTotal}}) சமமாக இருக்க வேண்டும்.",
    partiallyPaidInvalid: "பகுதியாக செலுத்திய ஆர்டர்களுக்கு, செலுத்திய தொகை ({{totalPaid}}) மொத்தத் தொகையை ({{grandTotal}}) விட குறைவாக இருக்க வேண்டும்.",
  },
};
